// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"177":"home","353":"homedoc","942":"article"}[chunkId] + "." + {"177":"b3967e88","353":"8356fcac","942":"11bcfc36"}[chunkId] + ".chunk.css";
};